import { render, staticRenderFns } from "./BlockWrapper.vue?vue&type=template&id=a64f3154&scoped=true"
import script from "./BlockWrapper.vue?vue&type=script&lang=js"
export * from "./BlockWrapper.vue?vue&type=script&lang=js"
import style0 from "./BlockWrapper.vue?vue&type=style&index=0&id=a64f3154&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64f3154",
  null
  
)

export default component.exports